import {
  Button,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { saveCalibrationSubject } from '../../../../store/apis/calibrationService';
import './ChangeReason.scss';
import changeReason from '../../../../assets/images/calibration/changeReason.png';
import { initialValues, validationSchema } from './constants';

function ChangeReason({
  isOpen,
  toggle,
  draggedEmployee,
  onDone,
  refetchAllData,
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const { mutate: updateRating } = useMutation({
    mutationFn: saveCalibrationSubject,
    onSuccess: () => {
      toast.success('Rating updated successfully.', {
        className: 'toast-success',
      });
      reset();
      onDone();
      refetchAllData();
    },
  });

  const onSubmit = async values => {
    updateRating({
      sessionId: draggedEmployee?.sessionId,
      empCd: draggedEmployee?.empCd,
      pcmRating: draggedEmployee?.pcmRating,
      performanceRating: draggedEmployee?.performanceRating,
      overallRating: draggedEmployee?.overallRating,
      ratingComment: values?.reason,
      userId: draggedEmployee?.userId,
      status: draggedEmployee?.status,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="modal-change-reason-confirmation"
      modalClassName="custom-modal-size"
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader
        style={{ fontSize: '18px', fontWeight: '600' }}
        toggle={toggle}
      >
        <div className="change-reason-header">
          <img
            alt=""
            src={changeReason}
            style={{ width: '42px', height: '42px' }}
          />
          <div className="title">Reason for Change</div>
        </div>
      </ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody style={{ fontSize: '14px', fontWeight: '400' }}>
          <div>
            <Label>
              Reason
              <span className="text-danger"> *</span>
            </Label>
            <Controller
              control={control}
              name="reason"
              render={({ field: element }) => (
                <Input
                  {...element}
                  type="textarea"
                  placeholder="Enter reason for change"
                  className="form-control external-filter-input"
                  rows={4}
                />
              )}
            />
            {errors?.reason && (
              <div className="invalid-feedback d-block">
                {errors.reason.message}
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter className="modalFooter">
          <Button className="item custom-light-btn" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" className="item custom-btn" disabled={!isValid}>
            Done
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default ChangeReason;
